<template>
  <appointment-form
      v-if="initCustomer"
      :initAppointment="initAppointment"
      :initCustomer="initCustomer"
      :successMsg="t('created')"
      :submitAction="submit"
      enableClearForm
      clearFormOnSubmit
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AppointmentForm from '@/views/appointments/AppointmentForm.vue'

import Appointment from '@/models/customer/Appointment'
import Customer from '@/models/customer/Customer'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'new-appointment',

  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          created: 'Appointment was created successfully'
        },
        ar: {
          created: 'تم انشاء الموعد بنجاح'
        }
      }
    })

    return { t }
  },

  components: {
    AppointmentForm
  },
  data() {
    return {
      initAppointment: new Appointment(),
      initCustomer: null as Customer | null
    }
  },
  async mounted() {
    if (this.$route.query.customer_id) {
      this.initCustomer = await this.$http.get<Customer>(
          Customer.ENDPOINT + `/${this.$route.query.customer_id}`
      )
      this.initAppointment.customerID = String(this.$route.query.customer_id)
    } else {
      this.initCustomer = new Customer()
    }
  },
  methods: {
    async submit(appointment: Appointment) {
      try {
        appointment.appointmentDate = undefined
        await this.$http.post(Appointment.ENDPOINT, appointment)
        await this.$router.back()
      } catch (error) {
        return error
      }
    }
  }
})
</script>

<style></style>
